module.exports = __webpack_public_path__ + "img/Fuchs.79ce2ac6.jpg";